import { useCallback, useState } from "react";
import AppSelect from "../../../../shared/components/AppSelect";
import { useAuth } from "../../../auth/shared/hooks/useAuth";
import { getLeague } from "../../shared/services/leagueService";
import { useLeagueResource } from "../../shared/hooks/useLeagueResource";
import { getLeagueRosterTexts } from "../../shared/leagueRosterTexts";
import LeagueFeedback from "../../shared/components/LeagueFeedback";
import LeagueLoadError from "../../shared/components/LeagueLoadError";
import LeagueRosterEditor from "./LeagueRosterEditor";

export default function LeagueParticipantsEditor({ leagueId }: { leagueId: string }) {
  const { token } = useAuth();
  const t = getLeagueRosterTexts();
  const [selection, setSelection] = useState("");
  const [editing, setEditing] = useState(false);
  const load = useCallback(() => getLeague(leagueId, token), [leagueId, token]);
  const resource = useLeagueResource(load);
  if (resource.loading) return <LeagueFeedback>{t.loading}</LeagueFeedback>;
  if (resource.error || !resource.data) return <LeagueLoadError error={resource.error || t.error} retry={resource.retry} />;
  const league = resource.data;
  const divisions = league.seasons.flatMap(season => season.divisions.map(division => ({ ...division, year: season.year, status: season.status })));
  const selected = divisions.find(division => division.id === selection) || divisions[0];
  return <>
    <h2>{league.name}</h2>
    <label className="league-division-select">{t.season} / {t.division}
      <AppSelect disabled={editing} value={selected?.id || ""} onChange={event => setSelection(event.target.value)}>
        {divisions.map(division => <option value={division.id} key={division.id}>{division.year} — {t[division.gender]}</option>)}
      </AppSelect>
    </label>
    {selected && <LeagueRosterEditor key={`${selected.id}-${token}`} token={token} leagueId={leagueId} divisionId={selected.id} onEditingChange={setEditing} locked={league.status === "archived" || selected.status !== "planning"} />}
  </>;
}
